import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import api from 'utils/api';
import { CURRENCY_FALLBACKS } from 'utils/currency';

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState({
    code: 'AED',
    symbol: 'Ð',
    name: 'UAE Dirham'
  });

  const fetchActiveCurrency = useCallback(async () => {
    try {
      const res = await api.get('/currency/list');
      if (res.data && res.data.status && Array.isArray(res.data.data)) {
        const active = res.data.data.find((c) => c.status === true) || res.data.data[0];
        if (active) {
          const rawSymbol = active.symbol || 'AED';
          const resolvedSymbol = CURRENCY_FALLBACKS[rawSymbol] || rawSymbol;
          setCurrency({
            code: rawSymbol,
            symbol: resolvedSymbol,
            name: active.name || 'UAE Dirham'
          });
        }
      }
    } catch (err) {
      console.error('Error fetching active currency:', err);
    }
  }, []);

  useEffect(() => {
    fetchActiveCurrency();
    const interval = setInterval(fetchActiveCurrency, 10000);
    return () => clearInterval(interval);
  }, [fetchActiveCurrency]);

  const value = useMemo(() => ({
    currency,
    refreshCurrency: fetchActiveCurrency
  }), [currency, fetchActiveCurrency]);

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
}

CurrencyProvider.propTypes = {
  children: PropTypes.node
};

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
}
